import React, { forwardRef, useEffect, useRef, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { ShowToast } from '../../common/Toastr';
import moment from 'moment';
import "react-datepicker/dist/react-datepicker.css";
import Select, { StylesConfig } from 'react-select';
import { displayValueForTimeEntry, getDecimalFromTime } from '../../common/timesheetFunction';
import CsvDownloader from 'react-csv-downloader';
import { usePapaParse } from 'react-papaparse';
import { getValueFromResource,dropDownSelectionStyles, FormatInvoiceDecimalNumber } from '../../common/timeLiveFunction';
import {
    getReimburseCurrencyAsync, updateReimburseCurrencyId, updateExpenseSheetDescription, getCalculateAmountAndReimburseAsync,
    updateAccountExpenseSheetAsync, getExpenseEntriesByAccountEmployeeExpenseSheetIdAsync,updateIsDiscriptionPopup,getDataAccountEmployeeExpenseSheetByAccountEmployeeExpenseSheetIdAsync
} from '../../features/expense/expenseSlice';
import { KTSVG } from '../../_metronic/helpers';
import { useLocation } from 'react-router-dom';
import { useTranslation } from "react-i18next";

const CurrencyDescriptionWidget = forwardRef((props : any, ref) => {
    const lockButton = props.lockButton;
    const formik = props.formik;
    const parentSelectedDate = props.SelectedDate;
    const customFieldsArray2 = props.customFieldArray2 || [];
  React.useImperativeHandle(ref, () => ({
    childMethod: handleUpdateSheet
  }));
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const { accountBaseCurrencyId,maxMenuHeight, CurrentCultureDateFormat,cultureInfoName,decimalPlaces } = useAppSelector((state) => state.globalState)
    const { expenseSheetList, reimbursecurrencyList, accountCurrencyId, AccountEmployeeId, expensesheetDate, expenseSheetDescription, MasterEmployeeExpenseSheetId,
        expenseSheetMasterList, expenseEntryList, reimburseCurrencyId,IsDescriptionPopup,isReload,SheetSubmitted,SheetApproved, LockSubmittedRecord, LockApprovedRecord } = useAppSelector((state) => state.expense);
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [currencyName, setCurrencyName] = useState<String | ''>('');
    const [isCurrencyUpdate, setIsCurrencyUpdate] = useState(false);
    const [selectedOption, setSelectedOption] = useState<{ [object: string]: any }>();
    const [currencyArray, setCurrencyArray] = useState<any | ''>([]);
    const [isSearchable, setIsSearchable] = useState(true);
    const [SelectedText, setSelectedText] = useState(moment(expensesheetDate).format("YYYY-MM-DD"));   
    const [labelReimburseAmount, setLabelReimburseAmount] = useState(FormatInvoiceDecimalNumber(cultureInfoName.toString(), 0, decimalPlaces));
    const [isPopup, setIsPopup] = useState(true);
    const location = useLocation();
    const { obj } = location.state || {};
    let AccountEmployeeExpenseSheetId = '';
    if (MasterEmployeeExpenseSheetId && MasterEmployeeExpenseSheetId !== '') {
        AccountEmployeeExpenseSheetId = MasterEmployeeExpenseSheetId;           
    } else if (obj && obj.AccountEmployeeExpenseSheetId) {
        AccountEmployeeExpenseSheetId = obj.AccountEmployeeExpenseSheetId;
    }
    const isVisible = AccountEmployeeExpenseSheetId && AccountEmployeeExpenseSheetId.length > 0;

    useEffect(() => {
        dispatch(getReimburseCurrencyAsync());
    }, []);

     useEffect(() => {
        if (parentSelectedDate && AccountEmployeeExpenseSheetId === '') {
            const formattedDate = moment(parentSelectedDate).format("YYYY-MM-DD");
            setSelectedText(formattedDate);
            dispatch(updateExpenseSheetDescription(formattedDate));
        }
    }, [parentSelectedDate]);

    useEffect(() => {

        if (AccountEmployeeExpenseSheetId !== '') {
            if (Object.keys(expenseSheetMasterList).length > 0) {
                const tempObj: any = expenseSheetMasterList[0];
                setSelectedText(tempObj.Description);
                dispatch(updateExpenseSheetDescription(tempObj.Description));
            }
            if (Object.keys(expenseEntryList).length > 0) {
                const ObjExpenseEntryList: any = expenseEntryList[0];
                let ReimburseValue: any = 0;
                if (ObjExpenseEntryList.ReimbursementCurrencyId === 0) {
                    const currencyMap = reimbursecurrencyList.reduce((map, item) => {
                        map[item.AccountCurrencyId] = item.CurrencyCode;
                        return map;
                    }, {} as { [key: string]: string });

                    const selectedCurrencyCode = currencyMap[accountBaseCurrencyId.toString()];
                    if (selectedCurrencyCode) {
                        setSelectedOption({ value: accountBaseCurrencyId, label: selectedCurrencyCode });
                        dispatch(updateReimburseCurrencyId(accountBaseCurrencyId));
                    }
                    setSelectedOption({ value: accountBaseCurrencyId, label: selectedCurrencyCode });
                    ReimburseValue = accountBaseCurrencyId;

                } else {
                    setSelectedOption({ value: ObjExpenseEntryList.ReimbursementCurrencyId, label: ObjExpenseEntryList.ReimbursementCurrencyCode });
                    ReimburseValue = ObjExpenseEntryList.ReimbursementCurrencyId;
                    dispatch(updateReimburseCurrencyId(ObjExpenseEntryList.ReimbursementCurrencyId));
                }

                const sheetdate = moment(ObjExpenseEntryList.ExpenseSheetDate).format('YYYY-MM-DD');
                const objReimburse = { "AccountEmployeeExpenseSheetId": AccountEmployeeExpenseSheetId, "ReimbursementCurrencyId": ReimburseValue, "ExpenseSheetDate": sheetdate }
                dispatch(getCalculateAmountAndReimburseAsync(objReimburse))
                    .unwrap()
                    .then((originalPromiseResult) => {
                        setLabelReimburseAmount(FormatInvoiceDecimalNumber(cultureInfoName.toString(), originalPromiseResult[0].ReimburseAmount, decimalPlaces));
                    })
                    .catch((rejectedValueOrSerializedError) => {
                        console.log('Error Reimburse Calculate Amount', rejectedValueOrSerializedError);
                    })
            }
        } else {
            setSelectedText(moment(expensesheetDate).format("YYYY-MM-DD"));
            setLabelReimburseAmount(FormatInvoiceDecimalNumber(cultureInfoName.toString(), 0, decimalPlaces));

            dispatch(updateExpenseSheetDescription(SelectedText));

            const currencyMap = reimbursecurrencyList.reduce((map, item) => {
                map[item.AccountCurrencyId] = item.CurrencyCode;
                return map;
            }, {} as { [key: string]: string });

            const selectedCurrencyCode = currencyMap[accountBaseCurrencyId.toString()];
            if (selectedCurrencyCode) {
                setSelectedOption({ value: accountBaseCurrencyId, label: selectedCurrencyCode });
                dispatch(updateReimburseCurrencyId(accountBaseCurrencyId));
            }

        }
    }, [AccountEmployeeExpenseSheetId, expenseSheetMasterList, expenseEntryList])

   

    let getCurrencyName = '';
    let array: any[] = [];
    reimbursecurrencyList.map(item => {
        array.push({ value: item.AccountCurrencyId, label: item.CurrencyCode })
        if (item != undefined) {
            getCurrencyName = item.CurrencyCode;
        }
    });


    if (getCurrencyName !== currencyName && getCurrencyName !== undefined && !isCurrencyUpdate) {
        setCurrencyName(getCurrencyName);
        if (array.length > 0) {
            const selected = array.find(x => x.value === accountBaseCurrencyId) || array[0];
            setSelectedOption(selected);
            dispatch(updateReimburseCurrencyId(selected.value));

        }
        setCurrencyArray(array);
    }


    const onCurrencyChange = (data: any) => {
        setIsCurrencyUpdate(true);
        dispatch(updateReimburseCurrencyId(data.value));
        setSelectedOption(data);
        // if (AccountEmployeeExpenseSheetId !== ''){
          
        //     handleUpdateSheet(data.value);
        // }
       
    }
    const onDescriptionChange = (e: any) => {
        setSelectedText(e.target.value);
        dispatch(updateExpenseSheetDescription(e.target.value));
    }
    const handleSubmit = () => {
    }

            const getFormattedCustomField = (fieldName: string, value: any) => {
                console.log("getFormattedCustomField .customFieldsArray", props.customFieldsArray)

 if (!customFieldsArray2 || customFieldsArray2.length === 0) {
        return value;
    }
                
        const field = customFieldsArray2.find((item: any) => item.DatabaseFieldName === fieldName);
        // If field exists, is type Number, and has a value
        if (field && field.MasterCustomDataTypeName === 'Number' && value) {
            return value.toString().replace(',', '.');
        }
        return value;
    };

    const updateExpenseSheetMasterList = (expenseSheetMasterList: any, reimbursementCurrencyId?: number) => {
        return expenseSheetMasterList.map((item: any) => {
            const updatedItem = {
                ...item,
                AccountEmployeeExpenseSheetId: AccountEmployeeExpenseSheetId,
                AccountEmployeeId: AccountEmployeeId,
                ExpenseSheetDate: expensesheetDate,
                Description: expenseSheetDescription,
                ReimbursementCurrencyId: reimbursementCurrencyId || reimburseCurrencyId,
                'CustomField1':  getFormattedCustomField('CustomField1', formik.values.CustomField1), 
                'CustomField2': getFormattedCustomField('CustomField2', formik.values.CustomField2),
                'CustomField3': getFormattedCustomField('CustomField3', formik.values.CustomField3),
                'CustomField4': getFormattedCustomField('CustomField4', formik.values.CustomField4),
                'CustomField5': getFormattedCustomField('CustomField5', formik.values.CustomField5),
                'CustomField6': getFormattedCustomField('CustomField6', formik.values.CustomField6), 
                'CustomField7': getFormattedCustomField('CustomField7', formik.values.CustomField7),
                'CustomField8': getFormattedCustomField('CustomField8', formik.values.CustomField8),
                'CustomField9': getFormattedCustomField('CustomField9', formik.values.CustomField9), 
                'CustomField10': getFormattedCustomField('CustomField10', formik.values.CustomField10),
                'CustomField11': getFormattedCustomField('CustomField11', formik.values.CustomField11), 
                'CustomField12': getFormattedCustomField('CustomField12', formik.values.CustomField12),
                'CustomField13': getFormattedCustomField('CustomField13', formik.values.CustomField13),
                'CustomField14': getFormattedCustomField('CustomField14', formik.values.CustomField14),
                'CustomField15': getFormattedCustomField('CustomField15', formik.values.CustomField15)
            };
            delete updatedItem.Amount;
            delete updatedItem.EMailAddress;
            delete updatedItem.EmployeeName;
            delete updatedItem.Currency;
            delete updatedItem.CurrencyCode;
            delete updatedItem.AccountCurrencyId;
            delete updatedItem.Status;
            return updatedItem;
        });
    };


    const handleUpdateSheet = (reimbursementCurrencyId?: number) => {
        const ExpenseSheetData = updateExpenseSheetMasterList(expenseSheetMasterList, reimbursementCurrencyId);
        setSelectedText(ExpenseSheetData.Description)
        dispatch(updateAccountExpenseSheetAsync({ AccountEmployeeExpenseSheetId: AccountEmployeeExpenseSheetId, ExpenseSheetData: ExpenseSheetData }))
            .unwrap()
            .then((originalPromiseResult) => {
                originalPromiseResult.StatusCode === "200" ?
                    ShowToast('Expense Sheet Successfully Update', 'Success', "success", "toast-top-right") :
                    ShowToast('error', originalPromiseResult.message, "error", "toast-top-right");
                if (AccountEmployeeExpenseSheetId !== null) {
                    dispatch(getDataAccountEmployeeExpenseSheetByAccountEmployeeExpenseSheetIdAsync(AccountEmployeeExpenseSheetId));
                    dispatch(getExpenseEntriesByAccountEmployeeExpenseSheetIdAsync(AccountEmployeeExpenseSheetId));                   
                    //dispatch(updateIsDiscriptionPopup(false));
                   
                }
            })
            .catch((rejectedValueOrSerializedError) => {
                ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
            })
    }


    return (
       
                <div className={"col-md-12 col-sm-12 col-xs-12"}>
                    <h4 className="card-title fw-bold titleHeading">
                        {/* {t(`Update Sheet`)} */}
                        {getValueFromResource('Update Sheet',dispatch, t)}
                        </h4>
                    <div className="separator my-2"></div>
                    <div className="mb-3 col-md-12 col-xs-12">
                        <div className="row col-md-12 col-xs-12 mb-1">
                            <div className="col-md-9">
                                <label className="fs-7 fs-7 fw-normal">
                                    {/* {t('Reimbursement Currency')} */}
                                    {getValueFromResource('Reimbursement Currency',dispatch, t)}
                                    </label>
                            </div>
                            <div className="col-md-3" style={{ textAlign: 'right', paddingRight: '0px' }}>
                                <span className="fw-bold d-block fs-7 text-danger">{labelReimburseAmount}</span>
                            </div>
                        </div>
                         <div 
                            data-kt-menu-dismiss="false" 
                            onClick={(e) => e.stopPropagation()}
                        >

                        <Select
                            value={selectedOption}
                            className="basic-single"
                            classNamePrefix="select"
                            isSearchable={isSearchable}
                            name="reimbursecurrencyList"
                            onChange={onCurrencyChange}
                            options={currencyArray}
                            styles={dropDownSelectionStyles}
                            maxMenuHeight={maxMenuHeight}
                            isDisabled={(SheetSubmitted && LockSubmittedRecord) || (SheetApproved && LockApprovedRecord)} 
                        />
                    </div>
                    </div>

                    <div className="mb-1">
                        <label className="fs-7 fs-7 fw-normal mb-1">
                            {/* {t('Description')} */}
                            {getValueFromResource('Description',dispatch, t)}
                            </label>
                        <div className={"form-group"}>
                            <textarea id="txtTimesheetDescription" value={SelectedText} onChange={onDescriptionChange} className={"form-control fs-7 fs-7 fw-normal"} rows={4} style={{ borderRadius: 0 }}>
                            </textarea>
                        </div>
                    </div>

                    {/* <div className="separator my-2"></div> */}
                    {/* {isVisible && (
                        <>
                            <div className="d-flex justify-content-end" style={{ padding: '.6rem .6rem' }}>
                                <button type="button" 
                                 className={`btn btn-primary  btn-bs-btn-font-weight btn-sm p-2 fs-7 ${lockButton ? 'disableClick' : ''}`}                    
                                onClick={
                                     () => {
                                          formik.setFieldValue('buttonClicked', 'handleUpdateSheet');
                                          formik.handleSubmit(); 
                                        }
                                  }
                                disabled={!formik.isValid || lockButton}
                                >
                                   {t('Update')}
                                </button>
                            </div>
                        </>
                    )} */}
                </div>
            
       
    )

})

const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: '100%', minHeight: '35px', height: '35px', padding: '-1px', borderColor: '#EBECF0' })
}

export default CurrencyDescriptionWidget
